import React, { useCallback, useEffect, useState } from 'react'
import { Alert, Card, Col, Container, Row, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import axiosInstance from '../services/axiosInterceptor'

// ภาพรวมงานค้างของงานธุรการ
export default function AoDashboard() {
  const [counts, setCounts] = useState(null)
  const [error, setError] = useState('')

  const fetchData = useCallback(async () => {
    setError('')
    try {
      const res = await axiosInstance.get('/api/ao/dashboard')
      if (res.data.success) setCounts(res.data.data)
    } catch (err) {
      setError(err.response?.data?.message || 'โหลดข้อมูลไม่สำเร็จ')
    }
  }, [])

  useEffect(() => { fetchData() }, [fetchData])

  const tiles = counts ? [
    { label: 'หนังสือรับรอดำเนินการ', value: counts.incoming_pending, icon: 'ri-inbox-archive-line', link: '/admin-office/incoming', color: 'primary' },
    { label: 'บันทึกรอเสนอแฟ้ม', value: counts.memo_to_propose, icon: 'ri-folder-received-line', link: '/admin-office/memos', color: 'warning' },
    { label: 'แฟ้มรอผู้บริหารพิจารณา', value: counts.memo_awaiting_exec, icon: 'ri-folder-shield-2-line', link: '/admin-office/memos', color: 'info' },
    { label: 'การจองรออนุมัติ', value: counts.booking_pending, icon: 'ri-calendar-check-line', link: '/admin-office/booking-approval', color: 'warning' },
    { label: 'มติที่ประชุมค้างติดตาม', value: counts.resolutions_open, icon: 'ri-task-line', link: '/admin-office/resolutions', color: 'danger' },
    { label: 'คำขอหนังสือรับรองค้าง', value: counts.certificates_requested, icon: 'ri-award-line', link: '/admin-office/certificates', color: 'primary' },
    { label: 'เอกสารใกล้หมดอายุ (60 วัน)', value: counts.archive_expiring, icon: 'ri-safe-2-line', link: '/admin-office/archive', color: 'danger' },
    { label: 'จดหมายเหตุรอ ผอ. ลงนาม', value: counts.daily_logs_awaiting_sign, icon: 'ri-booklet-line', link: '/admin-office/daily-log', color: 'info' },
  ] : []

  return (
    <>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <Container fluid>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h4 className="main-title mb-0">
              <i className="ri-dashboard-2-line me-2 text-primary" />
              ภาพรวมงานธุรการ
            </h4>
          </div>

          {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}

          {!counts ? (
            <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
          ) : (
            <Row className="g-3">
              {tiles.map(t => (
                <Col key={t.label} xs={6} md={4} xl={3}>
                  <Card as={Link} to={t.link} className="card-one text-decoration-none h-100">
                    <Card.Body className="d-flex align-items-center gap-3">
                      <div className={`text-${t.color}`} style={{ fontSize: '1.8rem' }}>
                        <i className={t.icon} />
                      </div>
                      <div>
                        <div className={`fs-3 fw-bold ${Number(t.value) > 0 ? `text-${t.color}` : 'text-muted'}`}>
                          {t.value}
                        </div>
                        <div className="text-muted fs-sm">{t.label}</div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>
      <Footer />
    </>
  )
}
